export class AgreementResponseDto {
  institution_id: string
  id: string
  created: string
  max_historical_days: number
  access_valid_for_days: number
  access_scope: string[]
  accepted: string
}